(function () {
  function getSwiperCtor() {
    // 번들에서 Swiper가 전역에 어떻게 노출되었는지 케이스별로 방어
    return window.Swiper || window.swiper || window.default || window.SWIPER || window.Z;
  }

  function initOne(swiperEl) {
    if (swiperEl._initDone) return;
    const Sw = getSwiperCtor();
    if (!Sw) { console.warn('[Swiper] constructor not found'); return; }

    swiperEl._initDone = true;

    const perViewDesktop = parseInt(swiperEl.dataset.columnsDesktop || '2', 10);
    const perViewMobile  = parseInt(swiperEl.dataset.columnsMobile  || '1', 10);
    const gapDesktop     = parseInt(swiperEl.dataset.spaceBetween   || '24', 10);
    const gapMobile      = parseInt(swiperEl.dataset.spaceBetweenMobile || swiperEl.dataset.spaceBetween || '12', 10);

    new Sw(swiperEl, {
      slidesPerView: perViewMobile,
      spaceBetween: gapMobile,
      watchOverflow: true,
      breakpoints: {
        750: { slidesPerView: perViewDesktop, spaceBetween: gapDesktop }
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true
      }
      // 필요하면 화살표:
      // navigation: {
      //   nextEl: swiperEl.querySelector('.swiper-button-next'),
      //   prevEl: swiperEl.querySelector('.swiper-button-prev')
      // }
    });
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('.custom-product-cards .swiper').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
